import type {RouteConfig} from 'vue-router'

export const routes: RouteConfig[] = [
  {
    path: '/master/login',
    name: 'menu.master.login_management.title',
    component: () => import('@/pages/Master/LoginUsers/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/master/material-family',
    name: 'common.material_family',
    component: () => import('@/pages/Master/MaterialFamily/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/master/material-variety/',
    name: 'common.material_variety',
    component: () => import('@/pages/Master/MaterialVariety/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/master/grade',
    name: 'common.grade',
    component: () => import('@/pages/Master/Grade/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/master/member',
    name: 'menu.master.member.title',
    component: () => import('@/pages/Master/Member/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/master/setting',
    name: 'menu.master.setting.title',
    component: () => import('@/pages/Master/Setting/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/master/customers',
    name: 'menu.master.setting.title',
    component: () => import('@/pages/Master/Customer/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/master/products',
    name: 'processed_product.name',
    component: () => import('@/pages/Product/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/master/products/:id/copy',
    name: 'processed_product.product_material_copy',
    component: () => import('@/pages/Product/ProductDetails.vue'),
    meta: {
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/master/products/:id',
    name: 'processed_product.product_material',
    component: () => import('@/pages/Product/ProductDetails.vue'),
    meta: {
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/master/products/create',
    name: 'processed_product.product_material_create',
    component: () => import('@/pages/Product/ProductDetails.vue'),
    meta: {
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/master/box-type',
    name: 'master.box_type.title',
    component: () => import('@/pages/Master/BoxType/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/master/bloom',
    name: 'master.bloom_num.title',
    component: () => import('@/pages/Master/Bloom/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/master/size',
    name: 'master.size.title',
    component: () => import('@/pages/Master/Size/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/master/processing-company',
    name: 'processing_company.name',
    component: () => import('@/pages/Master/ProcessingCompany/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/master/processing-company/:id',
    name: 'processing_company.details_company',
    component: () => import('@/pages/Master/ProcessingCompany/ProcessingCompanyDetails.vue'),
    meta: {
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/master/processing-company/create',
    name: 'processing_company.create_company',
    component: () => import('@/pages/Master/ProcessingCompany/ProcessingCompanyDetails.vue'),
    meta: {
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/master/supplier',
    name: 'master.supplier.title',
    component: () => import('@/pages/Master/Supplier/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/master/customer',
    name: 'master.customer.title',
    component: () => import('@/pages/Master/CustomerMaster/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/master/logistic-company',
    name: 'master.logistic_company.title',
    component: () => import('@/pages/Master/LogisticCompany/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/master/user',
    name: 'master.user.title',
    component: () => import('@/pages/Master/User/index.vue'),
    meta: {
      requiresAuth: true
    }
  }
]
